<template>
    <ValidationObserver ref="courseForm">
        <div class="row" >
            <div v-if="courses.length > 0" class="width-full">
                <table class="table table-bordered table-responsive">
                    <tr>
                        <th class="width-100">{{ $t('course_code').toUpper() }}</th>
                        <th>{{ $t('course_name').toUpper()}}</th>
                        <th>{{ $t('type').toUpper()}}</th>
                        <th>{{ $t('credit').toUpper()}}</th>
                        <th>{{ $t('modality').toUpper()}}</th>
                        <th>{{ $t('action').toUpper()}}</th>
                    </tr>
                    <tr v-for="course in courses" v-bind:key="course.id">
                        <td :class="course.course_id===selectedCourse?.course_id?'green-300':''">{{ course.course_code ? course.course_code : '' }}</td>
                        <td :class="course.course_id===selectedCourse?.course_id?'green-300':''">{{course.course_name }}
                        </td>
                        <td :class="course.course_id===selectedCourse?.course_id?'green-300':''">{{ course.course_type_name }}</td>
                        <td :class="course.course_id===selectedCourse?.course_id?'green-300':''">{{ course.course_credit }}</td>
                        <td :class="course.course_id===selectedCourse?.course_id?'green-300':''">{{ course.modality }}</td>
                        <td :class="course.course_id===selectedCourse?.course_id?'green-300':''">
                            <b-button  variant="primary" @click="saveCourse(course)" class="fs-6">
                                {{$t('choose')}}
                            </b-button>
<!--                            <b-form-group v-slot="{ ariaDescribedby }">-->
<!--                                <b-form-radio v-model="selectedCourse" :aria-describedby="ariaDescribedby" name="some-radios" :value="course"></b-form-radio>-->
<!--                            </b-form-group>-->
                        </td>
                    </tr>
                </table>
<!--                <div class="col-12 mt-3 d-flex justify-content-center align-center">-->
<!--                    <b-button type="submit" @click="saveCourse" variant="primary">{{ $t('save') }}</b-button>-->
<!--                </div>-->
            </div>
                <b-col v-else class="d-flex justify-content-center align-items-center"
                       style="min-height: 400px">
                    <b-spinner variant="primary" label="Loading..."></b-spinner>
                </b-col>

        </div>
    </ValidationObserver>
</template>
<script>
import CourseAgreementFormServices from "@/services/CourseAgreementFormServices";
export default {
    props:{
        courseId:Number,
        isNISlot:Boolean
    },
    data(){
        return {
          courses:[],
            selectedCourse: null,
            loading: false,
        }
    },
    created() {
        this.getCourses()
    },
    methods:{
        async saveCourse(selectedCourse){
            if (!selectedCourse){
                this.$toast.error(this.$t("please_select_a_course"))
                return
            }
            this.$swal.fire({
                title: this.$t('attention'),
                text: this.$t('course_agreement_form_selected_course_message'),
                showCancelButton: true,
                confirmButtonText: this.$t('yes'),
                cancelButtonText: this.$t('no'),
            }).then((result) => {
                if (result.isConfirmed) {
                        const data = {
                            external_id:selectedCourse.course_id,
                            student_slot_id:this.courseId
                        }
                        if (this.isNISlot){
                            delete data.student_slot_id
                        }
                       CourseAgreementFormServices.storeCourseAgreement(data)
                           .then((response) => {
                               this.$toast.success(this.$t("proccess_success"));
                               this.$emit('successCreate')
                           }).catch((error) => {
                               this.showErrors(error);
                       })


                }
            })
        },
       async getCourses(){
            try {
                const res = await CourseAgreementFormServices.courseList()
                this.courses = res.data.data
            }catch (error) {
                this.showErrors(error)
            }
        }
    },

}
</script>
<style scoped>
.green-300 {
    background-color: #86EFAC; /* Tailwind's green-300 */
}
</style>
